var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgResources = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#9292AF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "m16.068 2.096 9.6 4.8A2.4 2.4 0 0 1 27 9.044V20.48a2.4 2.4 0 0 1-1.332 2.148l-9.6 4.8a2.4 2.4 0 0 1-2.148 0l-9.6-4.8A2.4 2.4 0 0 1 3 20.468V9.044a2.4 2.4 0 0 1 1.332-2.148l9.6-4.8a2.4 2.4 0 0 1 2.136 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#9292AF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "m3.383 7.749 11.616 5.808 11.616-5.808M15 27.668V13.556"
})));
export default SvgResources;